import React, { memo, useEffect, useState } from 'react';
import SettingList from './SettingList';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import CostomTooltip from '../../common/CostomTooltip';

interface SettingUserProps {
  searchQuery?: string;
}
const SettingUsers = (props: SettingUserProps) => {
  const { searchQuery } = props;

  const navigate = useNavigate();
  const [userCount, setUserCount] = useState(0);
  const [subscriptionData, setSubscriptionData] = useState<any>(null);

  useEffect(() => {
    setTimeout(() => {
      const subscriptionPlanDetail = sessionStorage.getItem('planDetail');
      if (subscriptionPlanDetail) {
        setSubscriptionData(JSON.parse(subscriptionPlanDetail));
      }
    }, 100);
  }, [userCount, sessionStorage.getItem('planDetail')]);

  return (
    <>
      <div className="">
        {/* <div className="flex justify-between mb-1 ps-4 pe-6 mt-4">
          <h1 className="md:text-base  font-medium text-white sm:text-[14px]">Users</h1>
          <CostomTooltip text={`Your can't add more user. Please upgrade to continue.`}
            position="left"
            isDisabled={userCount >= subscriptionData?.data?.user_vendor_limit
              || subscriptionData?.data?.user_vendor_count >= subscriptionData?.data?.user_vendor_limit}

          >
            <div
              className="md:h-8 md:w-8 h-6 w-6 bg-[#006BEA] rounded-lg flex justify-center items-center cursor-pointer"
              onClick={() =>
                (userCount >= subscriptionData?.data?.user_vendor_limit ||
                  subscriptionData?.data?.user_vendor_count >= subscriptionData?.data?.user_vendor_limit) ? null : navigate('create-user')}
            >
              <FaPlus className="md:h-4 md:w-4 h-3 w-3" />
            </div>
          </CostomTooltip>
        </div> */}
        <div className="flex justify-between mb-1 ps-4 pe-6 mt-4">
          <h1 className="md:text-base font-medium text-white sm:text-[14px]">Users</h1>

          <div
            className="md:h-8 md:w-8 h-6 w-6 bg-[#006BEA] rounded-lg flex justify-center items-center cursor-pointer"
            onClick={() => {
              const { user_vendor_limit, user_vendor_count } = subscriptionData?.data || {};
              const isLimitReached =
                userCount >= user_vendor_limit || user_vendor_count >= user_vendor_limit;

              if (isLimitReached) {
                const confirmUpgrade = window.confirm(
                  'You’ve reached your user limit as per your subscription. Would you like to upgrade your plan?'
                );
                if (confirmUpgrade) {
                  sessionStorage.setItem('redirectFrom', window.location.pathname);
                  navigate(
                    `/subscription?recentPlanType=${subscriptionData?.data?.analytics}&updatePlan=${true}`
                  );
                }
              } else {
                navigate('create-user');
              }
            }}
          >
            <FaPlus className="md:h-4 md:w-4 h-3 w-3" />
          </div>
        </div>

        <SettingList searchQuery={searchQuery} setUserCount={setUserCount} />
      </div>
    </>
  );
};

export default memo(SettingUsers);
